export const callStates = [
  {
    value: 0,
    label: '启动中',
  },
  {
    value: 1,
    label: '电话连接中...',
  },
  {
    value: 2,
    label: '通话中',
  },
  {
    value: 3,
    label: '已挂断',
  },
  {
    value: 4,
    label: '对方已挂断',
  },
  {
    value: 5,
    label: '对方未接听',
  },
  {
    value: 6,
    label: '呼叫异常',
  },
  {
    value: 7,
    label: '电话呼入中',
  },
  {
    value: 8,
    label: '电话连接中...', // 连接中电话呼入
  },
  {
    value: 9,
    label: '通话中', // 通话中电话呼入
  },
];

export const callTypes = [
  {
    value: 1,
    label: '使用网络电话',
  },
  {
    value: 2,
    label: '使用外呼电话',
  },
];

export const alertStringMap = {
  FREQUENCY_LIMIT: '该用户今日已呼叫3次了，请明日再联系',
  INDUSTRY_LIMIT: '受行业限制，暂时不支持拨打',
  backendError: '呼叫失败，请稍候重试',
};
export const CallType = {
  NET_OPTION: 1,
  NORMAL_OPTION: 2,
  NET: 3,
  NORMAL: 4,
};
export const DialogType = {
  NEED_CHECK: 0,
  SELECT_OPTION: 1,
  CONFIRM_CALL: 2,
  CALLING: 3,
  TEL_INVALID: 4,
  ACCOUNT_INVALID: 5,
  ACCOUNT_FREELOGIN: 6,
};
export const CallState = {
  NOT_START: 0,
  CONNECTING: 1,
  CALLING: 2,
  HANGED: 3,
  USERHANGED: 4,
  USERREJECTED: 5,
  CALLFAILED: 6,
  COMMINGCALL: 7,
  COMMINGCALLWHILECONNECTING: 8,
  COMMINGCALLWHILECALLING: 9,
};

export const CalloutState = {
  NOT_START: 0,
  CONNECTING: 1,
  CALLING: 2,
  HANGED: 3,
  USERHANGED: 4,
  USERREJECTED: 5,
  CALLFAILED: 6,
};

export const CallinState = {
  NOT_START: 0,
  COMMINGCALL: 7,
  COMMINGCALLWITHERROR: 6,
};

export const invalidAccounts = [
  20457,
  23552002,
  21276419,
  21244128,
  18525136,
  24046435,
  23316748,
  23316745,
  23316743,
  23316742,
  23316741,
  23316740,
  23316737,
  23316735,
  23316734,
  23316729,
  23316723,
  23316676,
  23316674,
  23316673,
  23316672,
  23316671,
  23316670,
  23316669,
  23316667,
  23316666,
  23315406,
  22127374,
  22126960,
  22126957,
  22126956,
  22126954,
  22126949,
  22126944,
  22126940,
  22126938,
  22126937,
  22126936,
  21188590,
  21178689,
  21178688,
  21178687,
  21178686,
  21178685,
  21177587,
  15075885,
  23406383,
  20861845,
  20861844,
  20861843,
  20861842,
  20861841,
  20259269,
  20259268,
  19936939,
  19908145,
];
